import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { BLANK_TYPE, IDocumentType } from 'document-type-picker-lib';
import { DocumentTypeServiceFactory } from 'document-type-picker-lib';
import { Namespace } from 'enums-lib';
import { ISection } from 'interfaces-lib';
import { IDestinationsForOutputFileType } from '../../../services/entity-type/entity-type-service.factory';
import { SectionComponentBase } from '../section-component-base';
import { OutputFileTypeBuilder } from './output-file-type-builder';

@Component({
    selector: 'app-output-file-type-section',
    templateUrl: 'output-file-type.component.html',
    styles: ['h3 mat-icon { font-size: 22px; height: 22px; width: 22px; }'],
    standalone: false
})
export class OutputFileTypeComponent extends SectionComponentBase implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() workflowConfigNamespace: string | Namespace;
  @Input() destination: IDestinationsForOutputFileType;
  @Input() multiple: boolean;
  @Input() entityType: string;
  @Input() forSignature = false;
  @Output() updateDocumentForDestinationType = new EventEmitter<{
    destinationType: string;
    documentType: IDocumentType;
  }>();
  outputFileType: string;

  constructor(private documentTypeServiceProvider: DocumentTypeServiceFactory) {
    super();
  }

  ngOnInit() {
    this.outputFileType = this.documentTypeServiceProvider.getService(this.workflowConfigNamespace).getDocumentTypeLabel();
  }

  documentTypeSelected(documentType: IDocumentType): void {
    this.updateDocumentForDestinationType.emit({
      destinationType: this.destination?.type,
      documentType: documentType?.id === BLANK_TYPE.id ? undefined : documentType
    });
  }
}
